export default "__VITE_ASSET__C695lS_I__"